exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ClickableChip__chip__20wyj{display:block}", ""]);

// exports
exports.locals = {
	"chip": "ClickableChip__chip__20wyj"
};